import { useEffect } from "react";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ResumeDatabaseList from "./ResumeDatabaseList";

const ResumeDatabaseBody = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex flex-col ">
      <div className="flex items-end">
        <div className="flex-1 flex justify-start">
          <LeftOutlined
            onClick={() => navigate(`/recruitment`)}
            className="cursor-pointer inline-flex items-center justify-center p-2 rounded-full transition-all duration-200 hover:border hover:border-gray-300 hover:shadow-md"
            style={{ fontSize: "35px" }}
          />
        </div>

        <h2 className="text-3xl font-bold text-center p-0 m-0">LIST OF RESUME</h2>

        <div className="flex-1" />
      </div>
      <div className="my-9 mx-6">
        <ResumeDatabaseList />
      </div>
    </div>
  );
};

export default ResumeDatabaseBody;
